import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ff43ccbe"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
import { navRoutes } from "@/router/modules/main.router";
import { ref } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    // import path from "path";
    const router = useRouter();
    const menus = ref(navRoutes);

    const handleSelect = (key, keyPath) => {
      console.log(key, keyPath);
      router.push(key);
    };

    const handleClickItem = item => {
      if (item?.meta?.url) {
        window.open(item?.meta?.url);
      } else {
        router.push(item.path);
      }
    }; // function resolvePath(basePath: string, routePath: string) {
    //   if (isExternalLink(routePath)) {
    //     return routePath;
    //   }
    //   return path.resolve(basePath, routePath);
    // }
    // function isExternalLink(routePath: string) {
    //   return isExternal(routePath);
    // }
    // function isExternal(path: string) {
    //   return /^(https?:|mailto:|tel:)/.test(path);
    // }


    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");

      const _component_el_sub_menu = _resolveComponent("el-sub-menu");

      const _component_el_menu = _resolveComponent("el-menu");

      return _openBlock(), _createBlock(_component_el_menu, {
        "default-active": _ctx.$route.meta && _ctx.$route.meta.activePath || _ctx.$route.path,
        class: "nav-menu",
        mode: "horizontal",
        "background-color": "#2657a6",
        "text-color": "#c8d5ff",
        "active-text-color": "#ffffff",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, menu => {
          return _openBlock(), _createElementBlock(_Fragment, null, [menu.children ? (_openBlock(), _createBlock(_component_el_sub_menu, {
            key: menu.path,
            index: menu.path,
            "popper-class": "nav-sub-menu"
          }, {
            title: _withCtx(() => [_createTextVNode(_toDisplayString(menu.name), 1)]),
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, child => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: child.path,
                index: child.path
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  onClick: _withModifiers($event => handleClickItem(child), ["stop"]),
                  style: {
                    "flex": "1"
                  }
                }, _toDisplayString(child.name), 9, _hoisted_1)]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 2
          }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: menu.path,
            index: menu.path
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(menu.name), 1)]),
            _: 2
          }, 1032, ["index"]))], 64);
        }), 256))]),
        _: 1
      }, 8, ["default-active"]);
    };
  }

});